module.exports = __webpack_public_path__ + "img/bg-image-18.bad6253a.jpg";